export type MotionTier = 'subtle' | 'normal' | 'arcade';

export type BurstKind = 'bubble' | 'coin' | 'celebration';

export type MilestoneType = '180' | '501' | 'checkout';

export type MilestoneHit = {
  type: MilestoneType;
  label: string;
};

const MOTION_TIER_KEY = 'oche-motion-tier';

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function getMotionTier(): MotionTier {
  if (prefersReducedMotion()) return 'subtle';
  try {
    const stored = localStorage.getItem(MOTION_TIER_KEY);
    if (stored === 'subtle' || stored === 'normal' || stored === 'arcade') return stored;
  } catch {
    /* ignore */
  }
  return 'arcade';
}

export function setMotionTier(tier: MotionTier): void {
  try {
    localStorage.setItem(MOTION_TIER_KEY, tier);
  } catch {
    /* ignore */
  }
}

export function burstParticleCount(tier: MotionTier, kind: BurstKind): number {
  if (tier === 'subtle') return kind === 'celebration' ? 8 : 0;
  if (tier === 'normal') {
    if (kind === 'celebration') return 16;
    if (kind === 'bubble') return 5;
    return 3;
  }
  if (kind === 'celebration') return 28;
  if (kind === 'bubble') return 8;
  return 4;
}

export function shouldAnimateMotion(tier: MotionTier): boolean {
  if (prefersReducedMotion()) return false;
  return tier !== 'subtle';
}

/** Detect arcade milestone when score increases. */
export function detectMilestone(prevScore: number, newScore: number, delta: number): MilestoneHit | null {
  if (delta <= 0) return null;
  if (newScore === 180 && prevScore !== 180) {
    return { type: '180', label: '180!' };
  }
  if (newScore === 501 && prevScore !== 501) {
    return { type: '501', label: '501!' };
  }
  if (newScore === 50 && prevScore < 50) {
    return { type: 'checkout', label: 'Bullseye!' };
  }
  return null;
}

export function elementCenter(el: HTMLElement): { x: number; y: number } {
  const rect = el.getBoundingClientRect();
  return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
}
